import { BaseSlotPopupView, SlotPopups, StartFreeSpinsPopupController } from '@cgs/machines';
import { SceneObject } from '@cgs/wge';

export class CorsicaStartFreeSpinsPopupView extends BaseSlotPopupView<StartFreeSpinsPopupController> {
  constructor(_root: SceneObject, popupView: SceneObject) {
    super(_root, popupView, null, SlotPopups.StartFreeSpins);
  }

  public async show(): Promise<void> {
    super.show();

    this.onAnimationCompleted();
  }

  public setFreeSpins(): void {}

  private onAnimationCompleted(): void {
    this.controller.onAnimCompleted();
  }
}
